import { render, staticRenderFns } from "./kcjs1-1.vue?vue&type=template&id=00a0de8c&scoped=true&"
import script from "./kcjs1-1.vue?vue&type=script&lang=js&"
export * from "./kcjs1-1.vue?vue&type=script&lang=js&"
import style0 from "./kcjs1-1.vue?vue&type=style&index=0&id=00a0de8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a0de8c",
  null
  
)

export default component.exports